module.exports = __webpack_public_path__ + "static/media/software-engineer.f7889fd8.svg";